/* eslint-disable no-underscore-dangle */

import React from 'react'
import moment from 'moment'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Terminal } from 'xterm'
import { FitAddon } from 'xterm-addon-fit'

// Components
import Term from 'app/views/components/Terminal'
import Icon from 'app/views/components/Icon'
import FileTree from 'app/views/components/FileTree'
import CountdownTimer from 'app/views/components/CountdownTimer'
import CodeReview from 'app/views/components/CodeReview'

import {
  pingContent,
} from 'app/state/modules/content'
import {
  resetLinter,
} from 'app/state/modules/linter'
import {
  changeVersion,
  initializeCodeReview,
  saveFile,
  saveAllFiles,
  showCodeReviewModal,
  onSubmiResults,
  setVersions,
  resetTabs,
  resetMarkers,
  setSelectedVersion,
  setInitialFile,
} from 'app/state/modules/codeReview'


// Utils
import analytics from 'app/views/utils/analytics'
import LessonSteps from 'app/views/components/LessonSteps'
import ModalCodeReview from 'app/views/components/Modals/ModalCodeReview'
import Loader from 'app/views/components/Loader'
import getLocalDateFromUTC from 'app/views/utils/getLocalDateFromUTC'

import CodeReviewLoader from './Loader'

class CodeReviewContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      fullScreen: false,
      resetDisabled: true,
      currentContent: null,
      timeOut: false,
    }
    this.onSubmit = this.onSubmit.bind(this)
    this.onResetSandbox = this.onResetSandbox.bind(this)
    this.onInitialize = this.onInitialize.bind(this)
    this.onRefSockets = this.onRefSockets.bind(this)
    this.onActiveReset = this.onActiveReset.bind(this)
    this.termRef = React.createRef()
    this.termRef2 = React.createRef()
    this.codeReview = null
    this.size = 's'
    if (window.innerWidth > 1200) {
      this.size = 'l'
    }
    if (window.innerWidth > 1600) {
      this.size = 'xl'
    }
    this.props.showCodeReviewModal('hide')
  }

  componentDidMount() {
    analytics.page('code-review')

    this.onInitialize()
    this.pingInterval = setInterval(() => {
      if (document.hasFocus() && this.props.sandboxUUID) {
        this.props.pingContent(this.props.match.params.id)
      }
    }, 5000)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.sandboxUUID !== this.props.sandboxUUID) {
      this.timeout = setTimeout(() => {
        this.onActiveReset()
      }, 5000)
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    if (this.pingInterval) {
      clearInterval(this.pingInterval)
    }
    if (this.socketTerminal) {
      this.socketTerminal.close()
    }
    if (this.socketSandbox) {
      this.socketSandbox.disconnect()
    }
    if (this.healthCheckInteval) {
      clearInterval(this.healthCheckInteval)
    }
    this.props.resetLinter(true)
  }

  onActiveReset() {
    this.setState({
      resetDisabled: false,
    })
  }

  onRefSockets(socketTerminal, socketSandbox) {
    this.socketTerminal = socketTerminal
    this.socketSandbox = socketSandbox
    try {
      if (this.healthCheckInteval) {
        clearInterval(this.healthCheckInteval)
      }
      this.healthCheckInteval = setInterval(async () => {
        if (this.socketTerminal) {
          this.socketTerminal.send(('1'.toString('base64')))
        }
      }, 20000)
    } catch (e) {
      console.error(e)
    }
  }

  onInitialize(reset = false, callback = false, cancelInitialFile = false) {
    let cb = false
    if (typeof callback === 'function') {
      cb = callback
    } else {
      cb = false
    }
    this.props.initializeCodeReview(
      this.termRef.current.getTerminal(),
      this.props.match.params.id,
      this.props.useK8s || (this.props.content || this.state.currentContent || {}).k8s_enabled || false,
      this.onRefSockets,
      cb,
      reset,
      cancelInitialFile,
    )
  }

  onSubmit() {
    const contentUUID = this.props.match.params.id
    this.props.onSubmiResults(contentUUID)
  }

  onResetSandbox(callback = false, cancelInitialFile) {
    this.setState({
      resetDisabled: true,
    }, () => {
      if (this.socketSandbox) {
        this.socketSandbox.disconnect()
      }
      if (this.socketTerminal) {
        this.socketTerminal.close()
      }
      this.socketSandbox = null
      this.socketTerminal = null
      this.props.resetTabs()
      this.termRef.current.getTerminal().clear()
      localStorage.removeItem('codingEditorSessions')
      this.onInitialize(true, callback, cancelInitialFile)
      this.props.setSelectedVersion('original')
    })
  }

  render() {
    const content = this.props.content
    const useK8s = this.props.useK8s || this.props.content.k8s_enabled
    return (
      <>
        <div>
          <div
            style={{ height: 75 }}
            className="uk-grid uk-background-muted"
          >
            <div
              className="uk-width-1-4 uk-flex uk-flex-middle"
              style={{
                maxWidth: 600,
              }}
            />
            <div className="uk-width-3-4 uk-padding-remove">
              <div
                className="uk-flex uk-flex-row"
                style={{ height: '100%' }}
              >
                <div
                  className="uk-width-medium uk-flex uk-flex-middle"
                >
                  <select
                    disabled={this.props.loadingVersion}
                    className="uk-form-small uk-select"
                    style={{
                      borderRadius: 500,
                    }}
                    onChange={(e) => {
                      if (e.target.value !== this.props.selectedVersion) {
                        if (e.target.value === 'original') {
                          this.onResetSandbox()
                          this.props.setSelectedVersion('original')
                        } else {
                          localStorage.removeItem('codingEditorSessions')
                          this.props.changeVersion(
                            e.target.value,
                            content.uuid,
                          )
                        }
                      }
                    }}
                    value={this.props.selectedVersion}
                  >
                    {(this.props.versions).map((version, i) => (
                      <option key={version.id} value={version.id}>
                        {`Version ${this.props.versions.length - i} - ${getLocalDateFromUTC(version.submitted_at).format('MMM  D,  YYYY @ h:mm a')}`}
                      </option>
                    ))}
                    <option value="original">Original Version</option>
                  </select>
                </div>

                <div
                  className="uk-width-expand uk-flex uk-flex-between uk-flex-middle"
                >
                  <div>
                    <button
                      onClick={() => {
                        if (!this.props.savingFiles) {
                          this.props.saveAllFiles()
                        }
                      }}
                      disabled={this.props.savingFiles}
                      type="button"
                      style={{ marginBottom: 0 }}
                      className="uk-button uk-button-small uk-button-primary  uk-margin-left"
                    >
                      {this.props.savingFiles ? 'Saving Changes...' : 'Save All Changes'}
                    </button>
                    {this.props.sandboxAppUrl && (
                      <button
                        target="_blank"
                        rel="noopener noreferrer"
                        type="button"
                        onClick={() => {
                          window.open(this.props.sandboxAppUrl, '_blank')
                        }}
                        className="uk-button uk-button-small uk-button-muted uk-margin-small-left"
                        style={{
                          border: '1px solid #DDDDDD',
                          marginBottom: 0,
                        }}
                      >
                        Open App
                      </button>
                    )}
                    <button
                      disabled={this.state.resetDisabled}
                      type="button"
                      onClick={this.onResetSandbox}
                      style={{
                        border: '1px solid #DDDDDD',
                        marginBottom: 0,
                        background: this.state.resetDisabled ? '#EEE' : null,
                        cursor: this.state.resetDisabled ? 'not-allowed' : null,
                      }}
                      className="uk-button uk-button-small uk-button-muted uk-margin-small-left"
                    >
                      Reset Sandbox
                    </button>
                  </div>
                  <button
                    type="button"
                    onClick={this.onSubmit}
                    disabled={this.props.savingFiles}
                    style={{ marginBottom: 0 }}
                    className="uk-button uk-button-small uk-button-secondary uk-margin-small-right"
                  >
                    Save and Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="uk-cover-container">
            <div data-uk-grid="">
              <div
                className="uk-width-1-4 uk-background-muted uk-inline"
                style={{
                  overflowX: 'auto',
                  maxHeight: 'calc(100vh - 155px)'
                }}
              >
                <div className="uk-padding" ref={(ref) => { this.lessonStepContainer = ref }}>
                  {this.size === 'xl' ? (
                    <h2>
                      {content.title}
                    </h2>
                  )
                    : (
                      <h3>
                        {content.title}
                      </h3>
                    )}
                  <LessonSteps
                    hideRestart
                    lessonStepContainerRef={this.lessonStepContainer}
                    noButtons={content.content_type === 'coding_challenge'}
                    noTitle
                    noModal
                    onClickBack={(stepIndex) => { this.props.handleClickBack(stepIndex) }}
                    onClickCircle={(stepIndex) => { this.props.handleClickCircle(stepIndex) }}
                    onClickDone={(stepIndex) => { this.props.handleClickDone(stepIndex) }}
                    onClickNext={(stepIndex) => { this.props.handleClickNext(stepIndex) }}
                    steps={content.steps}
                    hints={content.hints}
                    hasHint
                    onHintClick={() => {
                      this.props.showCodeReviewModal('hint')
                    }}
                    email=""
                    title={content.title}
                    description={content.description}
                    contentId={content.uuid}
                    lessonCompletionURL={content.lessonCompletionURL}
                    lessonCompletionText={content.lessonCompletionText}
                    currentProgress={content.current_progress}
                    hasTest={content.has_test}
                    contentType={content.content_type}
                    userId={this.props.userId}
                    idToken={this.props.idToken}
                    codeSubmissions={[]}
                  />
                </div>
              </div>
              <div uk-grid="" className="uk-grid-collapse uk-inline uk-flex uk-flex-1 uk-padding-remove uk-width-3-4" style={{ maxHeight: 'calc(100vh - 155px)' }}>
                <div
                  className="uk-width-1-3"
                  style={{
                    height: '55vh',
                    padding: 20,
                    borderLeft: '2px solid #EEEEEE',
                    borderRight: '2px solid #EEEEEE',
                    overflowY: 'auto',
                  }}
                >
                  <FileTree
                    lockedFiles={content.metadata.lockedFiles || {}}
                  />
                </div>
                <div
                  className="uk-width-2-3"
                  style={{
                    height: '55vh',
                  }}
                >
                  {!this.state.fullScreen && (
                    <CodeReview
                      contentUUID={content.uuid}
                      markers={this.props.markers || []}
                      lockedFiles={content.metadata.lockedFiles || {}}
                      onFullScreen={() => this.setState({
                        fullScreen: true,
                      }, () => {
                        window.ffterm = new Terminal({
                          fontSize: window.innerWidth <= 1400 ? 12 : 14,
                        })
                        window.fffitaddon = new FitAddon()
                        window.ffterm.open(document.getElementById('full-screen-terminal'))
                        window.ffterm.loadAddon(window.fffitaddon)
                        window.fffitaddon.fit()
                        window.ffterm.write(this.props.output)
                      })}
                    />
                  )}
                </div>
                <div
                  className="uk-width-1-1 terminal-container-code-review"
                  style={{
                    height: 'calc(45vh - 155px)',
                  }}
                >
                  <Term ref={this.termRef} />
                </div>

              </div>
            </div>
          </div>
        </div>
        {
          this.state.fullScreen && (
            <div
              style={{
                position: 'fixed',
                height: 'calc(100vh - 80px)',
                width: '100%',
                left: 0,
                top: 80,
                background: 'white',
                zIndex: 1001,
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <div
                style={{
                  width: '16vw',
                }}
                className="uk-padding"
              >
                <FileTree
                  lockedFiles={content.metadata.lockedFiles || {}}
                  hasSave
                />
              </div>
              <div
                style={{
                  width: '84vw',
                  maxHeight: 'calc(100vh-80px)',
                }}
              >
                <CodeReview
                  contentUUID={content.uuid}
                  markers={this.props.markers || []}
                  lockedFiles={content.metadata.lockedFiles || {}}
                  onFullScreen={() => this.setState({ fullScreen: false })}
                  isFullScreen
                  extra={(
                    <div
                      style={{
                        height: window.innerHeight - (this.props.openTabs === 0 ? 130 : 110),
                        position: 'relative',
                      }}
                    >
                      <Term
                        ref={this.termRef2}
                        disableInit
                        className=""
                        id="full-screen-terminal"

                      />
                      <Icon
                        onClick={() => this.setState({ fullScreen: false })}
                        name="fullscreen-exit"
                        style={{
                          position: 'absolute',
                          background: '#000',
                          cursor: 'pointer',
                          zIndex: 10003,
                          top: 10,
                          right: 20,
                        }}
                      />
                    </div>
                  )}
                />
              </div>
            </div>
          )
        }
        <ModalCodeReview
          onResetSandbox={this.onResetSandbox}
          onNextQuestion={null}
          updateParentContentHints={null}
          patchingTime={content.patchingTime}
          metadata={content.hacker_metadata}
          contentUUID={content.uuid}
          hints={content.hints || []}
          contentCompleted={Boolean(content.completed_at)}
          push={this.props.history.push}
          contentType={content.content_type}
        />
        {
          (
            (!this.socketSandbox && !useK8s)
            || !this.socketTerminal
            || !this.props.sandboxUUID
          )
          && (
            <CodeReviewLoader
              onResetSandbox={this.onResetSandbox}
            />
          )
        }
      </>
    )
  }
}

const mapStateToProps = ({ codeReview, auth, hacker }) => ({
  output: codeReview.output,
  idToken: auth.user.idToken,
  userId: hacker.profile.user_id,
  openTabs: (codeReview.tabs || []).length,
  markers: codeReview.markers,
  versions: codeReview.versions,
  sandboxUUID: codeReview.sandboxUUID,
  savingFiles: codeReview.savingFiles,
  selectedVersion: codeReview.selectedVersion,
  loadingVersion: codeReview.loadingVersion,
  sandboxAppUrl: codeReview.sandboxAppUrl,
  totalResets: codeReview.totalResets,
})

export default withRouter(connect(mapStateToProps, {
  initializeCodeReview,
  saveFile,
  saveAllFiles,
  showCodeReviewModal,
  onSubmiResults,
  pingContent,
  changeVersion,
  setVersions,
  setSelectedVersion,
  resetTabs,
  resetMarkers,
  setInitialFile,
  resetLinter,
})(CodeReviewContainer))
